<template>
  <span class="pt-timepicker">
    <input
      v-model="displayTime"
      :class="[inputClass, disabled ? 'pt-timepicker-disabled' : '']"
      :placeholder="placeholder"
      :disabled="disabled"
      readonly
      type="text"
      @click.stop="toggleDropdown"
    />
    <span
      v-if="showClearBtn && !disabled"
      class="clear-btn"
      @click.stop="resetTime"
    >
      &times;
    </span>
    <div
      v-if="showDropdown"
      class="overlay"
      @click.stop="toggleDropdown"
    />
    <div v-if="showDropdown" class="dropdown">
      <div class="select-list-label">
        <label>HH</label>
        <label>MM</label>
        <label>AM/PM</label>
      </div>
      <div class="select-list">
        <ul class="hours">
          <li
            v-for="hr in hours"
            :key="hr"
            :class="{active: hour === hr}"
            @click.stop="select('hour', hr)"
          >
            {{ hr }}
          </li>
        </ul>
        <ul class="minutes">
          <li
            v-for="m in minutes"
            :key="m"
            :class="{active: minute === m}"
            @click.stop="select('minute', m)"
          >
            {{ m }}
          </li>
        </ul>
        <ul class="apms">
          <li
            v-for="a in apms"
            :key="a"
            :class="{active: apm === a}"
            @click.stop="select('apm', a)"
          >
            {{ a }}
          </li>
        </ul>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  name: 'PtTimePicker',
  props: {
    hideClearButton: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minuteInterval: {
      type: Number,
      default: 5,
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
    value: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      apms: ['AM', 'PM'],
      showDropdown: false,
      hour: '',
      minute: '',
      apm: '',
    };
  },
  computed: {
    hours() {
      let hours = [];

      for (let ii = 1; ii <= 12; ii++) {
        if (ii <= 9) {
          hours.push(`0${ii}`);
        } else {
          hours.push(String(ii));
        }
      }

      return hours;
    },
    minutes() {
      let minutes = [];

      for (let ii = 0; ii < 60; ii = ii + this.minuteInterval) {
        if (ii <= 9) {
          minutes.push(`0${ii}`);
        } else {
          minutes.push(String(ii));
        }
      }

      return minutes;
    },
    displayTime() {
      if (!this.hour && !this.minute && !this.apm) {
        return '';
      }

      return `${this.hour || '00'}:${this.minute || '00'} ${this.apm}`;
    },
    showClearBtn() {
      if (this.hideClearButton) return false;

      return !this.showDropdown && (!!this.hour || !!this.minute || !!this.apm);
    },
  },
  watch: {
    value: function(newVal) {
      this.setValue(newVal);
    },
  },
  mounted() {
    this.setValue(this.value);
  },
  methods: {
    clearTime() {
      this.hour = '';
      this.minute = '';
      this.apm = '';
    },
    emitChange() {
      let hour = parseInt(this.hour || 0, 10);
      hour = this.apm === 'AM' && this.hour === 12 ? 0 : hour;
      hour = this.apm === 'PM' && this.hour !== 12 ? hour + 12 : hour;

      let minute = parseInt(this.minute || 0, 10);
      const date = new Date();
      date.setHours(hour, minute, 0, 0);

      this.$emit('input', date);
      this.$emit('change', date);
    },
    select(type, value) {
      if (type === 'hour') {
        this.hour = value;
        this.minute = this.minute || '00';
        this.apm = this.apm || 'AM';
      } else if (type === 'minute') {
        this.minute = value;
        this.hour = this.hour || '00';
        this.apm = this.apm || 'AM';
      } else if (type === 'apm') {
        this.apm = value;
      }

      this.emitChange();
    },
    setValue(val) {
      if (!val) {
        this.clearTime();
        return;
      }

      const date = new Date(val);
      let hour = date.getHours();
      const minute = date.getMinutes();
      const apm = hour >= 12 ? 'PM' : 'AM';
      hour = hour > 12 ? hour - 12 : hour;
      hour = hour <= 9 ? `0${hour}` : hour;

      this.hour = String(hour);
      this.minute = minute <= 9 ? `0${minute}` : String(minute);
      this.apm = apm;
    },
    resetTime() {
      this.clearTime();
      this.$emit('input', null);
      this.$emit('change', null);
    },
    toggleDropdown() {
      if (this.disabled) return;
      this.showDropdown = !this.showDropdown;
    },
  },
};
</script>
